import theme from '@/config/theme';
import styled from 'vue-styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  gap: 1rem;

  .vue-tabs {
    width: 100%;
  }

  .tab-container {
    display: flex;
    justify-content: center;
  }

  .vue-tabs .nav-pills > li.active > a,
  .vue-tabs .nav-pills > li.active > a:hover,
  .vue-tabs .nav-pills > li.active > a:focus {
    color: #fff;
    background-color: ${theme.colors.primaryBlue};
  }


`;
